import { Container } from '@ui/wrapper'
import Accordion from '@ui/accordion'
import { SectionWrapper, StyledText } from './style'

const StudienArea = ({ dataStudien, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {dataStudien && (
          <div>
            {dataStudien.section_title?.title && (
              <StyledText id="studien">
                <h4>{dataStudien.section_title.title}</h4>
              </StyledText>
            )}
            {dataStudien.items?.length > 0 && (
              <StyledText>
                <Accordion maxItems={5} data={dataStudien.items} />
              </StyledText>
            )}
          </div>
        )}
      </Container>
    </SectionWrapper>
  )
}

export default StudienArea
